const {
  APP_BUILD_ENV,
  NODE_ENV,
  SMILES_ENABLE,
  VUE_APP_BACKEND,
  EXTERNAL_CSS_LINK,
  SEND_FRONT_LOGS_ENABLE,
  VUE_APP_DEPLOY,
} = process.env;

const parseBackend = VUE_APP_BACKEND.includes('http')
  ? VUE_APP_BACKEND : ('http://').concat(VUE_APP_BACKEND);
const url = new URL(parseBackend);
const secureVA = url.protocol === 'https:' ? 's' : '';

const {
  host, protocol, hostname, pathname,
} = window.location;
const prefix = VUE_APP_DEPLOY === 'subfolder'
  ? `/${pathname.split('/')[1]}` : '';
const secure = protocol === 'https:' ? 's' : '';
const BACKEND_HTTP_PATH = hostname === 'localhost' ? `http${secureVA}://${url.host}${prefix}/` : `http${secure}://${host}${prefix}/`;
const BACKEND_WS_PATH = hostname === 'localhost' ? `ws${secureVA}://${url.host}${prefix}/` : `ws${secure}://${host}${prefix}/`;

export {
  APP_BUILD_ENV,
  BACKEND_HTTP_PATH,
  BACKEND_WS_PATH,
  NODE_ENV,
  SMILES_ENABLE,
  EXTERNAL_CSS_LINK,
  SEND_FRONT_LOGS_ENABLE,
  prefix,
};
